import * as React from 'react';
import DefaultIcon from './DefaultIcon';
export default (props) => (React.createElement(DefaultIcon, Object.assign({}, props),
    React.createElement("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" }),
    ";"));
